/* Svensk katalog for locale-closing-cash-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'clo.cash.quickComments': 'Snabbkommentarer',
  'clo.cash.quickCountLabel': 'Inventerad av vd',
  'clo.cash.quickCountText': 'Kontantkassan är fysiskt inventerad per 31.12.{{year}} av vd.',
  'clo.cash.quickSheetLabel': 'Inventeringsblankett sparad',
  'clo.cash.quickSheetText': 'Signerad inventeringsblankett är kontrollerad och sparad i verifikationsmappen.',
  'clo.cash.quickReportLabel': 'Kontrollerad mot kassarapport',
  'clo.cash.quickReportText': 'Inventeringen är kontrollerad mot kassarapporten per 31.12.{{year}}.',
  'clo.cash.openPosting': 'Skapa fri kontering',
  'clo.cash.postingTitle': 'Korrigera kontantkassa',
  'clo.cash.postingDescription': 'Korrigering efter kassainventering {{year}}',
  'clo.cash.postingLoadError': 'Kunde inte läsa in fri kontering.',
  'clo.cash.postingSaved': 'Konteringen är bokförd. Kontrollera differensen på nytt.',
});
